﻿export class FileSize {
  private Kilobyte = 1024;
  private Megabyte = this.Kilobyte * 1024;
  private Gigabyte = this.Megabyte * 1024;

  public get bytes(): number { return this._bytes; }
  public get kilobytes(): number { return this._bytes / this.Kilobyte; }
  public get megabytes(): number { return this._bytes / this.Megabyte; }
  public get gigabytes(): number { return this._bytes / this.Gigabyte; }

  private _bytes: number;

  constructor(bytes: number) {
    this._bytes = bytes;
  }

  public toString(): string {
    return new FormatsFileSize().execute(this);
  }
}

export class FormatsFileSize {
  public execute(model: FileSize): string {
    if (!model)
      return null;

    let suffix = 'B';
    let value = model.bytes;

    if (model.gigabytes >= 1) {
      value = model.gigabytes;
      suffix = "GB";
    }
    else if (model.megabytes >= 1) {
      value = model.megabytes;
      suffix = "MB";
    }
    else if (model.kilobytes >= 1) {
      value = model.kilobytes;
      suffix = "KB";
    }

    return (value * 1.0).toFixed(1) + ' ' + suffix;
  }
}


export default FileSize;